// sentinel id used to represent the "Uncategorized" bucket when a viewer has
// no category assigned for a shared expense, or when an EXPENSE/INCOME row
// surfaces from a shared expense leftover the viewer cannot see the per-split
// category of. shared between backend (emit) and frontend (recognise + render).
export const UNCATEGORIZED_ID = 'uncategorized'
